export const LOGO_URL = "https://cdn.appio.so/app/appio.so/logo.png";
